// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

// Lazy-loaded Component
const TaskDetailsConfigurationList = lazy(
  () => import('pages/taskConfiguration/TaskDetailsConfigurationList')
);
const HoldUnholdConfigurationCreateEdit = lazy(
  () => import('pages/holdUnhold/config/HoldUnholdConfigurationCreateEdit')
);

const HoldUnholdTaskConfigRoute = (
  <Route path={routeName.holdReleaseTaskConfig}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.HOLD_RELEASE_TASK_CONFIG_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <TaskDetailsConfigurationList titleKey="task_config.config" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create/:programConfigId/:workflowId/:frequencyId"
      element={
        <PrivateRoute name={PrivateRouteConst.HOLD_RELEASE_TASK_CONFIG_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <HoldUnholdConfigurationCreateEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default HoldUnholdTaskConfigRoute;
